<template>
  <div class="wrap">
    <st-header
      title="我的工单"
      :back-able="false"
      :home-able="true"
    >
      <template slot="header-right">
        <span @click="addOrder()">
          <i class="el-icon-circle-plus"></i>
        </span>
      </template>
    </st-header>
    <div class="orderCenter">
      <el-tabs v-model="activeName" :stretch="true" class="demo-tabs">
        <el-tab-pane label="处理中" name="process"><Process  :get-data="getData"/></el-tab-pane>
        <el-tab-pane label="待评价" name="evaluate">
          <Evaluate @isShow="show" ref="evaInit" :get-data="getData"/>
        </el-tab-pane>
        <el-tab-pane label="全部工单" name="all"
        >
          <All @isShow="show" ref="allInit" :get-data="getData"/>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="orderFoot">
      <el-button class="subBtn" @click="subBtn">提交工单</el-button>
    </div> -->
    <div class="evaluate" v-if="isShow">
      <div class="evaluateCenter">
        <div class="del" @click="del">x</div>
        <el-form :model="evaForm">
          <div class="star">
            <span>服务评级</span>
            <el-rate v-model="evaForm.evaluate_num"></el-rate>
          </div>
          <p class="startext">服务评价</p>
          <el-input
            type="textarea"
            rows="6"
            resize="none"
            show-word-limit
            v-model="evaForm.evaluate_desc"
            placeholder="您可以输入对Stone Group 售后服务的评价"
          ></el-input>
          <el-button @click="onSubmit" class="evaluateSub">提交评价</el-button>
        </el-form>
      </div>
    </div>
  </div>

</template>


<script>
import StHeader from "@/components/layout/Header.vue";
import All from "./all/index.vue";
import Evaluate from "./evaluate/index.vue";
import Process from "./process/index.vue";
export default {
  components: {
    "st-header": StHeader,
    All,
    Process,
    Evaluate,
  },
  props: {},
  data() {
    return {
      activeName: 'all',
      isShow: false,
      evaForm: {
        value: 0,
        desc: "",
        id: "",
      },
      code: "",
    };
  },
  created() {
    this.init();
  },
  mounted() {
    
  },
  watch: {
  },

  methods: {
    init() {
      let params = this.$route.params;
      this.code = params['code'];
      this.activeName = params['type'];
    },

    async getData(type) {
      let res = await this.$post(this.$api.stRmaOrderSelect, {
        mes_order_code: this.code,
        type: type
      }).catch((e) => {
        console.log(e);
      })
      return res;
    },
    addOrder() {
      this.$router.push("/saleRep/submit/" + this.code);
    },
    show(val) {
      this.evaForm.id = val;
      this.isShow = true;
    },
    del() {
      this.isShow = false;
      this.evaForm.evaluate_num = 0;
      this.evaForm.evaluate_desc = "";
      this.evaForm.id = "";
    },

    onSubmit() {
      if (this.evaForm.evaluate_num == 0 || !this.evaForm.evaluate_desc) {
        this.$toast.fail("评级和填写服务评价");
        return;
      }

      this.$post(this.$api.stRmaOrderEvaluate, this.evaForm).then((res) => {
        this.$toast.success(res.msg);
        this.isShow = false;
        this.evaForm.evaluate_num = 0;
        this.evaForm.evaluate_desc = "";
        this.evaForm.id = "";
        location.reload ();
      }).catch((e) => {
        console.log(e);
      })
    },
  },
};
</script>

<style lang='scss'>
.st-header-right {
  .el-icon-circle-plus {
    font-size: 30px;
    transform: translateY(7px);
    color: rgba(42, 130, 228, 1);
  }
}
.orderCenter {

  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__active-bar {
    background: rgb(255, 87, 51);
  }
  .el-tabs__item.is-active {
    color: rgb(255, 87, 51);
  }
  #tab-evaluate,
  #tab-all,
  #tab-process {
    height: 7vh;
    font-size: 14px;
  }
  .el-tab-pane {
    // background: rgba(243, 246, 250, 1);
    width: 100%;
    height: calc(100vh - 100px);
    // overflow: scroll;
  }

  .el-tabs__content {
    margin: 0px 24px;
  }
}
.orderFoot {
  width: 100%;
  height: 12vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .subBtn {
    width: 348px;
    height: 48px;
    background: rgba(255, 87, 51, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    border-radius: 15px;
  }
}

.evaluate {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  .evaluateCenter {
    background: rgba(238, 238, 238, 1);
    width: 80%;
    height: 340px;
    padding: 30px 16px 12px;
    position: relative;
    .del {
      position: absolute;
      top: 0;
      right: 0;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .star {
      display: flex;
      justify-content: left;
      align-items: center;
      margin-bottom: 30px;
      span {
        margin-right: 6px;
        color: rgba(80, 80, 80, 1);
        font-size: 14px;
      }
    }
    .startext {
      margin-bottom: 12px;
      color: rgba(80, 80, 80, 1);
      font-size: 14px;
    }
    .evaluateSub {
      margin-top: 10px;
      background: rgb(42, 130, 288);
      width: 100%;
      height: 50px;
      border-radius: 15px;
      color: #fff;
    }
  }
}
</style>


<style scoped>
  .orderCenter /deep/ .el-tabs__nav-wrap {
    height: 56px!important;
    background: white;
    margin-bottom: 1px;
    overflow: hidden;
  }
  .orderCenter /deep/ .el-tabs__item {
    height: 56px!important;
    line-height: 56px;
  }
</style>